export const REQUIRED_PROFILE_FIELDS = ['firstName', 'lastName', 'neighborhood', 'bio', 'phoneNumber'];

export const isProfileIncomplete = (profile) => {
  if (!profile) return true;
  return REQUIRED_PROFILE_FIELDS.some(
    (field) => !profile[field] || profile[field].trim() === ''
  );
};

export const isProfileComplete = (profile) => !isProfileIncomplete(profile);
